import { jsx as _jsx } from "react/jsx-runtime";
import { OperationListItem } from './OperationListItem';
export function OperationList({ operations }) {
    return (_jsx("div", { className: "flex flex-col space-y-2", children: operations.map(([path, pathItem, method, operation]) => (_jsx(OperationListItem, { path: path, pathItem: pathItem, method: method, operation: operation }, `${path}-${method}`))) }));
}
